import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/auth/updatePassword';

import { updatePassword } from './utils';

export default function* listenUpdatePassword() {
  yield takeEvery(actionTypes.updatePassword.toString(), updatePassword);
}
